/**
 * commerceGapsBuilder — slices de commerce que faltavam no FE (gaps do mapa
 * BE×FE). Isolado do commerceBuilder grande. Inicia com LossReason; cresce
 * com Cadência/Activity/etc nesta fase.
 *
 * @since fase FE cobertura-total
 */
import type { $Fetch } from 'ofetch';

import { HttpLossReasonGateway } from '@/infrastructure/http/HttpLossReasonGateway';
import { HttpCadenciaGateway } from '@/infrastructure/http/HttpCadenciaGateway';
import { HttpGatewayCredencialGateway } from '@/infrastructure/http/HttpGatewayCredencialGateway';
import { HttpActivityGateway } from '@/infrastructure/http/HttpActivityGateway';
import { HttpSolicitacaoDescontoExtraGateway } from '@/infrastructure/http/HttpSolicitacaoDescontoExtraGateway';
import {
  ListLossReasons, CreateLossReason, UpdateLossReason, DeleteLossReason,
} from '@/application/usecase/LossReasonUseCaseImpl';
import {
  ListCadencias, CreateCadencia, UpdateCadencia, DeleteCadencia,
} from '@/application/usecase/CadenciaUseCaseImpl';
import {
  ListGatewayCredenciais, CreateGatewayCredencial, UpdateGatewayCredencial, DeleteGatewayCredencial,
} from '@/application/usecase/GatewayCredencialUseCaseImpl';
import { ListActivities } from '@/application/usecase/ActivityUseCaseImpl';
import {
  ListSolicitacoesDescontoExtra, DecidirDescontoExtra,
} from '@/application/usecase/SolicitacaoDescontoExtraUseCaseImpl';

export function buildCommerceGapsSlice(httpClient: $Fetch) {
  const lossReasonGateway = new HttpLossReasonGateway(httpClient);
  const cadenciaGateway = new HttpCadenciaGateway(httpClient);
  const gatewayCredencialGateway = new HttpGatewayCredencialGateway(httpClient);
  const activityGateway = new HttpActivityGateway(httpClient);
  const solicitacaoDescontoExtraGateway = new HttpSolicitacaoDescontoExtraGateway(httpClient);

  const useCases = {
    listLossReasons: new ListLossReasons(lossReasonGateway),
    createLossReason: new CreateLossReason(lossReasonGateway),
    updateLossReason: new UpdateLossReason(lossReasonGateway),
    deleteLossReason: new DeleteLossReason(lossReasonGateway),
    listCadencias: new ListCadencias(cadenciaGateway),
    createCadencia: new CreateCadencia(cadenciaGateway),
    updateCadencia: new UpdateCadencia(cadenciaGateway),
    deleteCadencia: new DeleteCadencia(cadenciaGateway),
    listGatewayCredenciais: new ListGatewayCredenciais(gatewayCredencialGateway),
    createGatewayCredencial: new CreateGatewayCredencial(gatewayCredencialGateway),
    updateGatewayCredencial: new UpdateGatewayCredencial(gatewayCredencialGateway),
    deleteGatewayCredencial: new DeleteGatewayCredencial(gatewayCredencialGateway),
    listActivities: new ListActivities(activityGateway),
    listSolicitacoesDescontoExtra: new ListSolicitacoesDescontoExtra(solicitacaoDescontoExtraGateway),
    decidirDescontoExtra: new DecidirDescontoExtra(solicitacaoDescontoExtraGateway),
  };

  return { useCases };
}
